// To add the gmail style select all button to a bulk_action page:
// 1. import {initSelectAll} from "src/lib/select-all"
// 2. initSelectAll()
// 3. Add {{page}}.js to webpack
// 4. Add total_query_size context to your view

export function initSelectAll() {
    let selectAllCheckbox = document.getElementById('select-all-checkbox')
    let selectAllQuerysetButton = document.getElementById("select-all-queryset-button")

    if (selectAllCheckbox != null) {
        selectAllCheckbox.addEventListener("change", function () {
            toggleCheckboxesChecked(this);
            if (selectAllCheckbox.checked) {
                showInitialDiv()
            }
            else {
                // Checkbox is not checked
                hideInitialDiv()
            }
        })
    }

    if (selectAllQuerysetButton != null) {
        selectAllQuerysetButton.addEventListener("click", function () {
            selectAllQueryset()
        })
    }

}

function getAllCheckboxes() {
    return document.querySelectorAll('input[type="checkbox"].select-all-compatible');
}

function toggleCheckboxesState() {
    let checkboxes = getAllCheckboxes();
    for (let checkbox of checkboxes) {
        if (checkbox.hasAttribute('disabled')) {
            checkbox.removeAttribute('disabled')
        }
        else {
            checkbox.setAttribute('disabled', true)
        }
    }
}

function removeCheckboxesDisabledAttribute() {
    let checkboxes = getAllCheckboxes();
    for (let checkbox of checkboxes) {
        checkbox.removeAttribute('disabled')
    }
}

function toggleCheckboxesChecked(source) {
    let checkboxes = getAllCheckboxes();
    for (let checkbox of checkboxes) {
        if (checkbox !== source) {
            checkbox.checked = source.checked;
        }
    }
    document.getElementById("all_in_queryset").checked = false;
}

function showInitialDiv() {
    let initial = document.getElementById('initial-div')
    initial.style.display = 'block';
}


function hideInitialDiv() {
    let initial = document.getElementById('initial-div')
    initial.style.display = 'none';
}

function hideSelectAllDiv() {
    let select_all = document.getElementById('select-all-div')
    select_all.style.display = 'none';
}

function swapDivs() {
    let select_all = document.getElementById('select-all-div')

    if (select_all.style.display === 'block') {
        // If div is displayed, hide it
        select_all.style.display = 'none';
    }
    else {
        // Show the div
        select_all.style.display = 'block';
    }

    let initial_div = document.getElementById('initial-div')

    if (initial_div.style.display === 'block') {
        initial_div.style.display = 'none';
    }
    else {
        initial_div.style.display = 'block'
    }
}

// Listener function
function selectAllQueryset() {
    swapDivs();

    document.getElementById("clear-selections-button").addEventListener("click", function () {
        clearSelections(this);
    });
    // Disable checkbox
    toggleCheckboxesState();

    // Enable the hidden checkbox otherwise it won't submit correctly
    let hiddenSelectAllCheckBox = document.getElementById("all_in_queryset")
    hiddenSelectAllCheckBox.removeAttribute('disabled')
    hiddenSelectAllCheckBox.checked = true;
}

// Clear all selections and reset view
function clearSelections(source) {
    hideSelectAllDiv()
    hideInitialDiv()
    toggleCheckboxesChecked(source)
    removeCheckboxesDisabledAttribute()
}
